<template>
  <section :class="['questions-panel', { 'questions-panel--compact': compact }]">
    <div v-if="showHeader" class="questions-panel__header">
      <div>
        <p class="questions-panel__eyebrow">Contenido</p>
        <h3 class="questions-panel__title">Preguntas</h3>
      </div>
      <v-btn v-if="showClose" @click="$emit('close')" icon>
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </div>

    <v-tabs v-model="activeTab" class="questions-tabs">
      <v-tab>
        <span class="pillsPendingTitle">Mis Preguntas</span>
        ({{ myQuestions.length }})
      </v-tab>
      <v-tab>
        <span class="pillsPendingTitle">Preguntas Publicas</span>
        ({{ publicQuestions.length }})
      </v-tab>
    </v-tabs>

    <v-divider class="mb-0"></v-divider>

    <div v-if="activeTab === 0" class="questions-content">
      <div class="pa-4">
        <div v-if="loading" class="text-center py-4">
          <v-progress-circular
            indeterminate
            color="primary"
            class="mr-2"
          ></v-progress-circular>
          <span class="loading-text">Cargando preguntas...</span>
        </div>

        <div v-else-if="myQuestions.length === 0" class="text-center py-8">
          <p class="text-muted">No tienes preguntas aun</p>
        </div>

        <div v-else>
          <div v-for="(question, index) in myQuestions" :key="index" class="question-item mb-4">
            <div class="d-flex justify-space-between align-center">
              <div class="question-text">{{ question.question }}</div>
              <v-chip
                :color="question.is_public ? 'primary' : 'grey'"
                small
                class="ml-2"
              >
                {{ question.is_public ? 'Publica' : 'Privada' }}
              </v-chip>
            </div>
            <div class="question-meta mt-2">
              <span class="text-muted">{{ formatDate(question.created_at) }}</span>
            </div>

            <div v-if="question.attachments && question.attachments.length > 0" class="attachments-section mt-2">
              <div v-for="(attachment, aIndex) in question.attachments" :key="aIndex" class="attachment-item">
                <v-icon small class="mr-2">mdi-paperclip</v-icon>
                <a :href="attachment.file_path" target="_blank" class="attachment-link">
                  {{ attachment.original_name }}
                </a>
              </div>
            </div>

            <div v-if="question.responses && question.responses.length > 0" class="responses-section mt-3">
              <div v-for="(response, rIndex) in question.responses" :key="rIndex" class="response-item">
                <div class="d-flex align-center mb-2">
                  <v-avatar size="24" class="mr-2">
                    <img :src="response.user.profile_photo_url" :alt="response.user.name">
                  </v-avatar>
                  <strong class="response-author">{{ response.user.name }}</strong>
                </div>
                <div class="response-text">{{ response.response }}</div>
                <div class="response-date text-muted mt-1">{{ formatDate(response.created_at) }}</div>

                <div v-if="response.attachments && response.attachments.length > 0" class="attachments-section mt-2">
                  <div v-for="(attachment, aIndex) in response.attachments" :key="aIndex" class="attachment-item">
                    <v-icon small class="mr-2">mdi-paperclip</v-icon>
                    <a :href="attachment.file_path" target="_blank" class="attachment-link">
                      {{ attachment.original_name }}
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-if="activeTab === 1" class="questions-content">
      <div class="pa-4">
        <div v-if="loading" class="text-center py-4">
          <v-progress-circular
            indeterminate
            color="primary"
            class="mr-2"
          ></v-progress-circular>
          <span class="loading-text">Cargando preguntas...</span>
        </div>

        <div v-else-if="publicQuestions.length === 0" class="text-center py-8">
          <p class="text-muted">No hay preguntas publicas aun</p>
        </div>
        <div v-else>
          <div v-for="(question, index) in publicQuestions" :key="index" class="question-item mb-4">
            <div class="d-flex justify-space-between align-center">
              <div class="d-flex align-center">
                <div class="question-text">{{ question.question }}</div>
              </div>
              <v-chip color="primary" small class="ml-2">Publica</v-chip>
            </div>
            <div class="question-meta mt-2 d-flex align-center">
              <span class="text-muted">Preguntado por {{ question.learner.full_name }}</span>
              <v-divider vertical class="mx-2"></v-divider>
              <span class="text-muted">{{ formatDate(question.created_at) }}</span>
            </div>

            <div v-if="question.attachments && question.attachments.length > 0" class="attachments-section mt-2">
              <div v-for="(attachment, aIndex) in question.attachments" :key="aIndex" class="attachment-item">
                <v-icon small class="mr-2">mdi-paperclip</v-icon>
                <a :href="attachment.file_path" target="_blank" class="attachment-link">
                  {{ attachment.original_name }}
                </a>
              </div>
            </div>

            <div v-if="question.responses && question.responses.length > 0" class="responses-section mt-3">
              <div v-for="(response, rIndex) in question.responses" :key="rIndex" class="response-item">
                <div class="d-flex align-center mb-2">
                  <v-avatar size="24" class="mr-2">
                    <img :src="response.user.profile_photo_url" :alt="response.user.name">
                  </v-avatar>
                  <strong class="response-author">{{ response.user.name }}</strong>
                </div>
                <div class="response-text">{{ response.response }}</div>
                <div class="response-date text-muted mt-1">{{ formatDate(response.created_at) }}</div>

                <div v-if="response.attachments && response.attachments.length > 0" class="attachments-section mt-2">
                  <div v-for="(attachment, aIndex) in response.attachments" :key="aIndex" class="attachment-item">
                    <v-icon small class="mr-2">mdi-paperclip</v-icon>
                    <a :href="attachment.file_path" target="_blank" class="attachment-link">
                      {{ attachment.original_name }}
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="questions-form">
      <div class="d-flex justify-end mb-4">
        <v-switch
          v-model="isPublic"
          label="Hacer publica"
          hide-details
          class="mt-0"
          dense
          :disabled="loadingSubmit"
        ></v-switch>
      </div>
      <v-textarea
        v-model="newQuestion"
        label="Escribe tu pregunta"
        rows="2"
        auto-grow
        hide-details
        class="mb-4"
        outlined
        dense
        :disabled="loadingSubmit"
      ></v-textarea>

      <div class="mb-4">
        <input
          type="file"
          ref="fileInput"
          multiple
          accept="*/*"
          style="display: none"
          @change="handleFileChange"
        >
        <v-btn
          outlined
          color="grey"
          class="file-upload-btn"
          :disabled="loadingSubmit"
          @click="$refs.fileInput.click()"
        >
          <v-icon left>mdi-paperclip</v-icon>
          Adjuntar archivos
        </v-btn>

        <div v-if="selectedFiles.length > 0" class="selected-files mt-2">
          <div v-for="(file, index) in selectedFiles" :key="index" class="selected-file-item">
            <v-icon small class="mr-2">mdi-file</v-icon>
            <span class="file-name">{{ file.name }}</span>
            <v-btn
              x-small
              icon
              class="ml-2"
              @click="removeFile(index)"
              :disabled="loadingSubmit"
            >
              <v-icon small>mdi-close</v-icon>
            </v-btn>
          </div>
        </div>
      </div>

      <v-btn
        color="primary"
        block
        :disabled="!newQuestion.trim() || loadingSubmit"
        @click="addQuestion"
        class="containerBtn--seeRigthNow"
      >
        <template v-if="loadingSubmit">
          <v-progress-circular
            indeterminate
            size="20"
            width="2"
            color="white"
            class="mr-2"
          ></v-progress-circular>
          Enviando...
        </template>
        <template v-else>
          <v-icon class="mr-2" color="white">mdi-send</v-icon>
          <span>Enviar Pregunta</span>
        </template>
      </v-btn>
    </div>
  </section>
</template>

<script>
import moment from 'moment';
moment.locale('es');

export default {
  name: 'ContentQuestions',
  props: {
    active: {
      type: Boolean,
      default: true,
    },
    lessonId: {
      type: [Number, String],
      required: true,
    },
    courseId: {
      type: [Number, String],
      required: true,
    },
    scheduleId: {
      type: [Number, String],
      required: true,
    },
    compact: {
      type: Boolean,
      default: false,
    },
    showHeader: {
      type: Boolean,
      default: true,
    },
    showClose: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      activeTab: 0,
      newQuestion: '',
      isPublic: false,
      myQuestions: [],
      publicQuestions: [],
      loading: false,
      loadingSubmit: false,
      selectedFiles: [],
    };
  },

  watch: {
    active(newVal) {
      if (newVal) {
        this.loadQuestions();
      }
    },
    activeTab() {
      if (this.active) {
        this.loadQuestions();
      }
      this.isPublic = this.activeTab === 1;
      this.newQuestion = '';
    },
    lessonId() {
      if (this.active) this.loadQuestions();
    },
    scheduleId() {
      if (this.active) this.loadQuestions();
    },
  },

  mounted() {
    if (this.active) {
      this.loadQuestions();
    }
  },

  methods: {
    async loadQuestions() {
      try {
        this.loading = true;
        const response = await this.$store.dispatch('profile/LIST_LESSONS_QUESTION', {
          lesson_id: this.lessonId,
          schedule_id: this.scheduleId,
          is_public: this.activeTab === 1 ? 1 : 0,
        });

        if (this.activeTab === 0) {
          this.myQuestions = response.data.data;
        } else {
          this.publicQuestions = response.data.data;
        }
      } catch (error) {
        console.error('Error cargando preguntas:', error);
      } finally {
        this.loading = false;
      }
    },

    async addQuestion() {
      if (!this.newQuestion.trim() || this.loadingSubmit) return;

      try {
        this.loadingSubmit = true;
        const formData = new FormData();
        formData.append('lesson_id', this.lessonId);
        formData.append('course_id', this.courseId);
        formData.append('schedule_id', this.scheduleId);
        formData.append('question', this.newQuestion);
        formData.append('is_public', this.isPublic ? 1 : 0);

        this.selectedFiles.forEach((file, index) => {
          formData.append(`files[${index}]`, file);
        });

        const response = await this.$store.dispatch('profile/CREATE_LESSONS_QUESTION', formData);
        const newQuestion = response.data;

        if (this.isPublic) {
          this.publicQuestions.unshift({
            ...newQuestion,
            responses: [],
            learner: {
              full_name: 'Mi',
            },
          });
        }
        this.myQuestions.unshift(newQuestion);

        this.newQuestion = '';
        this.selectedFiles = [];
        this.isPublic = this.activeTab === 1;
        this.$snotify.success('Pregunta enviada exitosamente');
      } catch (error) {
        console.error('Error enviando pregunta:', error);
        this.$snotify.error('Error al enviar la pregunta');
      } finally {
        this.loadingSubmit = false;
      }
    },

    handleFileChange(event) {
      const files = Array.from(event.target.files);
      this.selectedFiles = [...this.selectedFiles, ...files];
    },

    removeFile(index) {
      this.selectedFiles.splice(index, 1);
    },

    formatDate(date) {
      return moment(date).format('DD MMM YYYY HH:mm');
    },
  },
};
</script>

<style scoped>
.questions-panel {
  height: 80vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  background: #fff;
  border-radius: 8px;
}

.questions-panel--compact {
  height: auto;
  min-height: 0;
  border-radius: 0;
}

.questions-panel__header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  padding: 20px 24px 14px;
  background: #fff;
}

.questions-panel__eyebrow {
  margin: 0 0 2px;
  color: #8a98a5;
  font: normal normal 400 12px/18px Poppins;
}

.questions-panel__title {
  margin: 0;
  font: normal normal 700 20px/28px Poppins;
  color: #101820;
}

.questions-tabs {
  flex: none;
  background: #fff;
}

.questions-content {
  flex: 1;
  overflow-y: auto;
  background: #fff;
}

.questions-panel--compact .questions-content {
  overflow: visible;
}

.questions-form {
  padding: 16px 24px 20px;
  background: #fff;
  border-top: 1px solid #eef2f6;
}

.questions-panel--compact .questions-form {
  padding: 14px 0 0;
}

.question-item {
  background: #f8fafc;
  padding: 16px;
  border-radius: 8px;
  border: 1px solid #edf1f5;
}

.question-text {
  font-size: 14px;
  line-height: 1.5;
  color: #333;
  word-break: break-word;
}

.question-meta {
  font-size: 12px;
  color: #666;
}

.text-muted {
  color: #6c757d;
}

.pillsPendingTitle {
  margin-right: 10px;
  text-align: left;
  font: normal normal 600 14px/22px Poppins;
  letter-spacing: 0;
  color: #101820;
  text-transform: capitalize;
}

.containerBtn--seeRigthNow {
  background: #0076ff 0% 0% no-repeat padding-box;
  border-radius: 32px;
  text-align: center;
  font: normal normal normal 13px/30px Poppins;
  letter-spacing: 0;
  color: #ffffff;
  padding: 9px 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-decoration: none;
}

.containerBtn--seeRigthNow[disabled] {
  opacity: 0.6;
  cursor: not-allowed;
  pointer-events: none;
}

.responses-section {
  border-left: 2px solid #d9e2ea;
  margin-left: 12px;
  padding-left: 12px;
  margin-top: 16px;
}

.response-item {
  background: #ffffff;
  padding: 12px;
  border-radius: 8px;
  margin-bottom: 8px;
  border: 1px solid #edf1f5;
  box-shadow: none;
}

.response-author {
  font-size: 13px;
  color: #333;
}

.response-text {
  font-size: 14px;
  color: #444;
  line-height: 1.4;
}

.response-date {
  font-size: 11px;
  color: #666;
}

.attachment-item {
  display: flex;
  align-items: center;
  padding: 4px 8px;
  background: #fff;
  border: 1px solid #edf1f5;
  border-radius: 8px;
  margin-top: 4px;
}

.attachment-link {
  color: #0076ff;
  text-decoration: none;
  font-size: 12px;
  word-break: break-all;
}

.attachment-link:hover {
  text-decoration: underline;
}

.selected-files {
  background: #f8fafc;
  border-radius: 8px;
  padding: 8px;
}

.selected-file-item {
  display: flex;
  align-items: center;
  padding: 4px 8px;
  background: white;
  border: 1px solid #edf1f5;
  border-radius: 8px;
  margin-bottom: 4px;
  font-size: 12px;
}

.file-name {
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.file-upload-btn {
  width: 100%;
  text-transform: none;
  border: 1px solid #d9e2ea;
  background-color: #f8fafc;
  color: #495057;
  font-size: 14px;
  height: 40px;
  border-radius: 8px;
}

.file-upload-btn:hover {
  background-color: #e9ecef;
  border-color: #0076ff;
  color: #0076ff;
}

.file-upload-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}
</style>
